module.exports = __webpack_public_path__ + "static/media/daibiao-title-1.3cfcf09c.png";